<template>
  <q-btn
    class="q-ml-sm"
    flat
    dense
    round
    icon="content_copy"
    size="xs"
    @click="copy"
  >
    <q-tooltip>Скопировать</q-tooltip>
  </q-btn>
</template>

<script>
import EventBus from "src/services/event-bus";

export default {
  name: "ClipboardButton",
  props: {
    text: String
  },
  data() {
    return {};
  },
  methods: {
    copy() {
      EventBus.$emit("utils:copy_to_clipboard", this.text);
    }
  },
  created() {}
};
</script>

<style lang="scss">
</style>